import React from 'react';
import classes from './BlueGradientBlock.module.scss'

interface Props {
    title: string
    text: string
}

const BlueGradientBlock:React.FC<Props> = ({title, text}) => {
    return (
        <div className={classes.block}>
            <div className={classes['bg']}>
            </div>
                <h4>{title}</h4>
                <span>{text}</span>
        </div>
    );
};

export default BlueGradientBlock;